import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export type CheckoutFee = {
    id: string;
    title: string;
    amount: string;
    is_active: boolean;
};

async function call<T>(request: Promise<Response>, fallback: string): Promise<T> {
    let response: Response;
    try {
        response = await request;
    } catch {
        throw new Error("Could not reach the server. Please check your connection and try again.");
    }
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.message || fallback);
    return data as T;
}

export const FeeRequests = {
    list: () =>
        call<CheckoutFee[]>(fetchWrapperPublic.get(`${API_BASE_URL}/data/fees/`), "Could not load fees."),
    create: (title: string, amount: string) =>
        call<CheckoutFee>(
            fetchWrapperPublic.post(`${API_BASE_URL}/data/fees/`, { title, amount }),
            "Could not add the fee.",
        ),
    update: (id: string, changes: Partial<Pick<CheckoutFee, "title" | "amount" | "is_active">>) =>
        call<CheckoutFee>(
            fetchWrapperPublic.patch(`${API_BASE_URL}/data/fees/${id}/`, changes),
            "Could not update the fee.",
        ),
    remove: (id: string) =>
        call<{ message: string }>(
            fetchWrapperPublic.delete(`${API_BASE_URL}/data/fees/${id}/`),
            "Could not delete the fee.",
        ),
};
